import { useMemo } from 'react';

import { useTracking } from '@change-corgi/core-react/tracking';

import { useStartAPetitionPageState } from '#src/app/pages/startAPetitionV2/pageContext';

import type { SandboxContract } from '../../types';

type SandboxActions = SandboxContract['actions'];
type SubmitParams = Parameters<SandboxActions['submit']>[0];
type UpdateParams = Parameters<SandboxActions['update']>[0];
type TrackingParams = Parameters<SandboxActions['track']>[0];

export function useSandbox(): SandboxContract {
	const { data, actions } = useStartAPetitionPageState();
	const track = useTracking();

	const sandboxData = useMemo(() => ({ draft: data.draft ?? {} }), [data.draft]);

	const sandboxActions = useMemo(
		() => ({
			back: () => actions.send({ type: 'back' }),
			update: ({ draft }: UpdateParams) => actions.send({ type: 'submit', target: 'self', draft }),
			submit: ({ draft, target }: SubmitParams) => actions.send({ type: 'submit', draft, target }),
			track: ({ eventName, eventData }: TrackingParams) => void track(eventName, eventData),
		}),
		[actions, track],
	);

	return { data: sandboxData, actions: sandboxActions };
}
